import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import {
  FILTER_HISTORY_STORAGE_KEY,
  FILTER_HISTORY_STORAGE_QUERY_KEY,
  type FilterHistoryItem,
  getFilterHistory,
} from './utils';

const useFilterHistory = (): FilterHistoryItem[] => {
  const queryClient = useQueryClient();
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === FILTER_HISTORY_STORAGE_KEY)
        queryClient.invalidateQueries({
          queryKey: FILTER_HISTORY_STORAGE_QUERY_KEY,
        });
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [queryClient]);

  const { data } = useQuery<FilterHistoryItem[]>({
    queryKey: FILTER_HISTORY_STORAGE_QUERY_KEY,
    queryFn: getFilterHistory,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return data || [];
};

export default useFilterHistory;
